import { render, staticRenderFns } from "./TableColumnHeader.vue?vue&type=template&id=52e9018e&"
import script from "./TableColumnHeader.vue?vue&type=script&lang=js&"
export * from "./TableColumnHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\invoiceasy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e9018e')) {
      api.createRecord('52e9018e', component.options)
    } else {
      api.reload('52e9018e', component.options)
    }
    module.hot.accept("./TableColumnHeader.vue?vue&type=template&id=52e9018e&", function () {
      api.rerender('52e9018e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/base-table/components/TableColumnHeader.vue"
export default component.exports